import React from 'react';

interface StoryTextProps {
  title: string;
  paragraphs: string[];
}

export default function StoryText({ title, paragraphs }: StoryTextProps) {
  return (
    <div className="space-y-4 sm:space-y-6">
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-light text-foreground tracking-tight leading-tight">
        {title}
      </h2>
      {paragraphs.map((paragraph, index) => (
        <p
          key={`story-para-${index}`}
          className="text-muted-foreground text-base sm:text-lg leading-relaxed"
        >
          {paragraph}
        </p>
      ))}
    </div>
  );
}